import React from 'react';
import { AlertTriangle, X } from 'lucide-react';
type ConfirmDialogProps = {
  isOpen: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  variant?: 'danger' | 'warning' | 'info';
};
export function ConfirmDialog({
  isOpen,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  variant = 'warning'
}: ConfirmDialogProps) {
  if (!isOpen) return null;
  const variantStyles = {
    danger: {
      icon: 'text-red-600',
      button: 'bg-red-600 hover:bg-red-700'
    },
    warning: {
      icon: 'text-yellow-600',
      button: 'bg-yellow-600 hover:bg-yellow-700'
    },
    info: {
      icon: 'text-blue-600',
      button: 'bg-blue-600 hover:bg-blue-700'
    }
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center" data-id="element-105">
      <div className="absolute inset-0 bg-black/30 backdrop-blur-sm" onClick={onCancel} data-id="element-106" />

      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4 p-6" data-id="element-107">
        <button onClick={onCancel} className="absolute top-4 right-4 p-1 text-gray-400 hover:text-gray-600" data-id="element-108">
          <X className="w-5 h-5" data-id="element-109" />
        </button>

        <div className="flex items-start gap-4 mb-4" data-id="element-110">
          <div className={`p-2 rounded-full bg-${variant === 'danger' ? 'red' : variant === 'warning' ? 'yellow' : 'blue'}-100`} data-id="element-111">
            <AlertTriangle className={`w-6 h-6 ${variantStyles[variant].icon}`} data-id="element-112" />
          </div>
          <div className="flex-1" data-id="element-113">
            <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-114">
              {title}
            </h3>
            <p className="text-gray-600" data-id="element-115">{message}</p>
          </div>
        </div>

        <div className="flex gap-3 mt-6" data-id="element-116">
          <button onClick={onCancel} className="flex-1 px-4 py-2 border-2 border-gray-300 text-gray-700 font-medium rounded-xl hover:bg-gray-50 transition-colors" data-id="element-117">
            {cancelText}
          </button>
          <button onClick={onConfirm} className={`flex-1 px-4 py-2 text-white font-medium rounded-xl transition-colors ${variantStyles[variant].button}`} data-id="element-118">
            {confirmText}
          </button>
        </div>
      </div>
    </div>;
}